<div id="layout" class="theme-cyan">
  <app-leftmenu></app-leftmenu>
  <!-- Main Body: Content -->
  <div class="main px-xl-5 px-lg-4 px-3">

    <!-- Body -->
    <div class="main-body">

      <!-- Body: Header -->
      <div class="body-header border-bottom py-xl-3 py-2">
        <div class="container px-0">

          <div class="row align-items-center">

            <!-- page title -->
            <div class="col-5 col-xl-4">
              <div class="media">
                <div class="media-body overflow-hidden">
                  <div class="d-flex align-items-center justify-content-between mb-1">
                    <h5 class="text-truncate mb-0 me-auto">Bootstrap Table</h5>
                  </div>
                  <small class="text-truncate text-muted">Get started Documentation with <a
                      href="https://getbootstrap.com/docs/4.5/getting-started/introduction/"
                      target="_black">Bootstrap</a></small>
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>

      <!-- Page Default -->
      <div class="body-page d-flex py-xl-3 py-2">
        <div class="container px-0">

          <!-- Doc: Introduction -->
          <div class="row">
            <div class="col-12">
              <h5 class="card-title mb-1">Basic Table</h5>
              <div class="card mb-5">
                <ul class="nav nav-pills py-3 px-4" role="tablist">
                  <li class="nav-item" role="presentation">
                    <a class="nav-link active" href="javascript:void(0)" (click)="onMenuTab('1')"
                      [ngClass]="{'active': viewTab}">View</a>
                  </li>
                  <li class="nav-item" role="presentation">
                    <a class="nav-link" href="javascript:void(0)" (click)="onMenuTab('2')"
                      [ngClass]="{'active': htmlTab}">HTML
                      code</a>
                  </li>
                </ul>
                <div class="card-body border-top">
                  <div class="tab-content">
                    <div class="tab-pane fade show active" id="table-view-1" [ngClass]="{'show active': viewTab}">
                      <table class="table">
                        <thead>
                          <tr>
                            <th scope="col">#</th>
                            <th scope="col">First</th>
                            <th scope="col">Last</th>
                            <th scope="col">Handle</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <th scope="row">1</th>
                            <td>Mark</td>
                            <td>Otto</td>
                            <td>@mdo</td>
                          </tr>
                          <tr>
                            <th scope="row">2</th>
                            <td>Jacob</td>
                            <td>Thornton</td>
                            <td>@fat</td>
                          </tr>
                          <tr>
                            <th scope="row">3</th>
                            <td>Larry</td>
                            <td>the Bird</td>
                            <td>@twitter</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="tab-pane fade" id="table-code-1" [ngClass]="{'show active': htmlTab}">
                      <pre><code class="language-html">&lt;table class=&quot;table&quot;&gt;
      &lt;thead&gt;
        &lt;tr&gt;
          &lt;th scope=&quot;col&quot;&gt;#&lt;/th&gt;
          &lt;th scope=&quot;col&quot;&gt;First&lt;/th&gt;
          &lt;th scope=&quot;col&quot;&gt;Last&lt;/th&gt;
          &lt;th scope=&quot;col&quot;&gt;Handle&lt;/th&gt;
        &lt;/tr&gt;
      &lt;/thead&gt;
      &lt;tbody&gt;
        &lt;tr&gt;
          &lt;th scope=&quot;row&quot;&gt;1&lt;/th&gt;
          &lt;td&gt;Mark&lt;/td&gt;
          &lt;td&gt;Otto&lt;/td&gt;
          &lt;td&gt;@mdo&lt;/td&gt;
        &lt;/tr&gt;
        &lt;tr&gt;
          &lt;th scope=&quot;row&quot;&gt;2&lt;/th&gt;
          &lt;td&gt;Jacob&lt;/td&gt;
          &lt;td&gt;Thornton&lt;/td&gt;
          &lt;td&gt;@fat&lt;/td&gt;
        &lt;/tr&gt;
        &lt;tr&gt;
          &lt;th scope=&quot;row&quot;&gt;3&lt;/th&gt;
          &lt;td&gt;Larry&lt;/td&gt;
          &lt;td&gt;the Bird&lt;/td&gt;
          &lt;td&gt;@twitter&lt;/td&gt;
        &lt;/tr&gt;
      &lt;/tbody&gt;
    &lt;/table&gt;</code></pre>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12">
              <h5 class="card-title mb-1">Basic Table Dark</h5>
              <p>You can also invert the colors—with light text on dark backgrounds—with <code
                  class="text-danger">.table-dark</code>.</p>
              <div class="card mb-5">
                <ul class="nav nav-pills py-3 px-4" role="tablist">
                  <li class="nav-item" role="presentation">
                    <a class="nav-link active" href="javascript:void(0)" (click)="onMenuTab1('1')"
                      [ngClass]="{'active': viewTab1}">View</a>
                  </li>
                  <li class="nav-item" role="presentation">
                    <a class="nav-link" href="javascript:void(0)" (click)="onMenuTab1('2')"
                      [ngClass]="{'active': htmlTab1}">HTML
                      code</a>
                  </li>
                </ul>
                <div class="card-body border-top">
                  <div class="tab-content">
                    <div class="tab-pane fade show active" id="table-view-2" [ngClass]="{'show active': viewTab1}">
                      <table class="table table-dark">
                        <thead>
                          <tr>
                            <th scope="col">#</th>
                            <th scope="col">First</th>
                            <th scope="col">Last</th>
                            <th scope="col">Handle</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <th scope="row">1</th>
                            <td>Mark</td>
                            <td>Otto</td>
                            <td>@mdo</td>
                          </tr>
                          <tr>
                            <th scope="row">2</th>
                            <td>Jacob</td>
                            <td>Thornton</td>
                            <td>@fat</td>
                          </tr>
                          <tr>
                            <th scope="row">3</th>
                            <td>Larry</td>
                            <td>the Bird</td>
                            <td>@twitter</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="tab-pane fade" id="table-code-2" [ngClass]="{'show active': htmlTab1}">
                      <pre><code class="language-html">&lt;table class=&quot;table table-dark&quot;&gt;
        &lt;thead&gt;
          &lt;tr&gt;
            &lt;th scope=&quot;col&quot;&gt;#&lt;/th&gt;
            &lt;th scope=&quot;col&quot;&gt;First&lt;/th&gt;
            &lt;th scope=&quot;col&quot;&gt;Last&lt;/th&gt;
            &lt;th scope=&quot;col&quot;&gt;Handle&lt;/th&gt;
          &lt;/tr&gt;
        &lt;/thead&gt;
        &lt;tbody&gt;
          &lt;tr&gt;
            &lt;th scope=&quot;row&quot;&gt;1&lt;/th&gt;
            &lt;td&gt;Mark&lt;/td&gt;
            &lt;td&gt;Otto&lt;/td&gt;
            &lt;td&gt;@mdo&lt;/td&gt;
          &lt;/tr&gt;
          &lt;tr&gt;
            &lt;th scope=&quot;row&quot;&gt;2&lt;/th&gt;
            &lt;td&gt;Jacob&lt;/td&gt;
            &lt;td&gt;Thornton&lt;/td&gt;
            &lt;td&gt;@fat&lt;/td&gt;
          &lt;/tr&gt;
          &lt;tr&gt;
            &lt;th scope=&quot;row&quot;&gt;3&lt;/th&gt;
            &lt;td&gt;Larry&lt;/td&gt;
            &lt;td&gt;the Bird&lt;/td&gt;
            &lt;td&gt;@twitter&lt;/td&gt;
          &lt;/tr&gt;
        &lt;/tbody&gt;
      &lt;/table&gt;</code></pre>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12">
              <h5 class="card-title mb-1">Striped rows</h5>
              <p>Use <span class="text-danger">.table-striped</span> to add zebra-striping to any table row within the
                <code class="text-danger"><tbody></code>.
              </p>
              <div class="card mb-5">
                <ul class="nav nav-pills py-3 px-4" role="tablist">
                  <li class="nav-item" role="presentation">
                    <a class="nav-link active" href="javascript:void(0)" (click)="onMenuTab2('1')"
                      [ngClass]="{'active': viewTab2}">View</a>
                  </li>
                  <li class="nav-item" role="presentation">
                    <a class="nav-link" href="javascript:void(0)" (click)="onMenuTab2('2')"
                      [ngClass]="{'active': htmlTab2}">HTML
                      code</a>
                  </li>
                </ul>
                <div class="card-body border-top">
                  <div class="tab-content">
                    <div class="tab-pane fade show active" id="table-view-3" [ngClass]="{'show active': viewTab2}">
                      <table class="table table-striped">
                        <thead>
                          <tr>
                            <th scope="col">#</th>
                            <th scope="col">First</th>
                            <th scope="col">Last</th>
                            <th scope="col">Handle</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <th scope="row">1</th>
                            <td>Mark</td>
                            <td>Otto</td>
                            <td>@mdo</td>
                          </tr>
                          <tr>
                            <th scope="row">2</th>
                            <td>Jacob</td>
                            <td>Thornton</td>
                            <td>@fat</td>
                          </tr>
                          <tr>
                            <th scope="row">3</th>
                            <td>Larry</td>
                            <td>the Bird</td>
                            <td>@twitter</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="tab-pane fade" id="table-code-3" [ngClass]="{'show active': htmlTab2}">
                      <pre><code class="language-html">&lt;table class=&quot;table table-striped&quot;&gt;
        &lt;thead&gt;
          &lt;tr&gt;
            &lt;th scope=&quot;col&quot;&gt;#&lt;/th&gt;
            &lt;th scope=&quot;col&quot;&gt;First&lt;/th&gt;
            &lt;th scope=&quot;col&quot;&gt;Last&lt;/th&gt;
            &lt;th scope=&quot;col&quot;&gt;Handle&lt;/th&gt;
          &lt;/tr&gt;
        &lt;/thead&gt;
        &lt;tbody&gt;
          &lt;tr&gt;
            &lt;th scope=&quot;row&quot;&gt;1&lt;/th&gt;
            &lt;td&gt;Mark&lt;/td&gt;
            &lt;td&gt;Otto&lt;/td&gt;
            &lt;td&gt;@mdo&lt;/td&gt;
          &lt;/tr&gt;
          &lt;tr&gt;
            &lt;th scope=&quot;row&quot;&gt;2&lt;/th&gt;
            &lt;td&gt;Jacob&lt;/td&gt;
            &lt;td&gt;Thornton&lt;/td&gt;
            &lt;td&gt;@fat&lt;/td&gt;
          &lt;/tr&gt;
          &lt;tr&gt;
            &lt;th scope=&quot;row&quot;&gt;3&lt;/th&gt;
            &lt;td&gt;Larry&lt;/td&gt;
            &lt;td&gt;the Bird&lt;/td&gt;
            &lt;td&gt;@twitter&lt;/td&gt;
          &lt;/tr&gt;
        &lt;/tbody&gt;
      &lt;/table&gt;</code></pre>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12">
              <h5 class="card-title mb-1">Bordered table</h5>
              <p>Add <span class="text-danger">.table-bordered</span> for borders on all sides of the table and cells.
              </p>
              <div class="card mb-5">
                <ul class="nav nav-pills py-3 px-4" role="tablist">
                  <li class="nav-item" role="presentation">
                    <a class="nav-link active" href="javascript:void(0)" (click)="onMenuTab3('1')"
                      [ngClass]="{'active': viewTab3}">View</a>
                  </li>
                  <li class="nav-item" role="presentation">
                    <a class="nav-link" href="javascript:void(0)" (click)="onMenuTab3('2')"
                      [ngClass]="{'active': htmlTab3}">HTML
                      code</a>
                  </li>
                </ul>
                <div class="card-body border-top">
                  <div class="tab-content">
                    <div class="tab-pane fade show active" id="table-view-4" [ngClass]="{'show active': viewTab3}">
                      <table class="table table-bordered">
                        <thead>
                          <tr>
                            <th scope="col">#</th>
                            <th scope="col">First</th>
                            <th scope="col">Last</th>
                            <th scope="col">Handle</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <th scope="row">1</th>
                            <td>Mark</td>
                            <td>Otto</td>
                            <td>@mdo</td>
                          </tr>
                          <tr>
                            <th scope="row">2</th>
                            <td>Jacob</td>
                            <td>Thornton</td>
                            <td>@fat</td>
                          </tr>
                          <tr>
                            <th scope="row">3</th>
                            <td colspan="2">Larry the Bird</td>
                            <td>@twitter</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="tab-pane fade" id="table-code-4" [ngClass]="{'show active': htmlTab3}">
                      <pre><code class="language-html">&lt;table class=&quot;table table-bordered&quot;&gt;
        &lt;thead&gt;
          &lt;tr&gt;
            &lt;th scope=&quot;col&quot;&gt;#&lt;/th&gt;
            &lt;th scope=&quot;col&quot;&gt;First&lt;/th&gt;
            &lt;th scope=&quot;col&quot;&gt;Last&lt;/th&gt;
            &lt;th scope=&quot;col&quot;&gt;Handle&lt;/th&gt;
          &lt;/tr&gt;
        &lt;/thead&gt;
        &lt;tbody&gt;
          &lt;tr&gt;
            &lt;th scope=&quot;row&quot;&gt;1&lt;/th&gt;
            &lt;td&gt;Mark&lt;/td&gt;
            &lt;td&gt;Otto&lt;/td&gt;
            &lt;td&gt;@mdo&lt;/td&gt;
          &lt;/tr&gt;
          &lt;tr&gt;
            &lt;th scope=&quot;row&quot;&gt;2&lt;/th&gt;
            &lt;td&gt;Jacob&lt;/td&gt;
            &lt;td&gt;Thornton&lt;/td&gt;
            &lt;td&gt;@fat&lt;/td&gt;
          &lt;/tr&gt;
          &lt;tr&gt;
            &lt;th scope=&quot;row&quot;&gt;3&lt;/th&gt;
            &lt;td colspan=&quot;2&quot;&gt;Larry the Bird&lt;/td&gt;
            &lt;td&gt;@twitter&lt;/td&gt;
          &lt;/tr&gt;
        &lt;/tbody&gt;
      &lt;/table&gt;</code></pre>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12">
              <h5 class="card-title mb-1">Borderless table</h5>
              <p>Add <span class="text-danger">.table-bordered</span> for borders on all sides of the table and cells.
              </p>
              <div class="card mb-5">
                <ul class="nav nav-pills py-3 px-4" role="tablist">
                  <li class="nav-item" role="presentation">
                    <a class="nav-link active" href="javascript:void(0)" (click)="onMenuTab4('1')"
                      [ngClass]="{'active': viewTab4}">View</a>
                  </li>
                  <li class="nav-item" role="presentation">
                    <a class="nav-link" href="javascript:void(0)" (click)="onMenuTab4('2')"
                      [ngClass]="{'active': htmlTab4}">HTML
                      code</a>
                  </li>
                </ul>
                <div class="card-body border-top">
                  <div class="tab-content">
                    <div class="tab-pane fade show active" id="table-view-5" [ngClass]="{'show active': viewTab4}">
                      <table class="table table-borderless">
                        <thead>
                          <tr>
                            <th scope="col">#</th>
                            <th scope="col">First</th>
                            <th scope="col">Last</th>
                            <th scope="col">Handle</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <th scope="row">1</th>
                            <td>Mark</td>
                            <td>Otto</td>
                            <td>@mdo</td>
                          </tr>
                          <tr>
                            <th scope="row">2</th>
                            <td>Jacob</td>
                            <td>Thornton</td>
                            <td>@fat</td>
                          </tr>
                          <tr>
                            <th scope="row">3</th>
                            <td colspan="2">Larry the Bird</td>
                            <td>@twitter</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="tab-pane fade" id="table-code-5" [ngClass]="{'show active': htmlTab4}">
                      <pre><code class="language-html">&lt;table class=&quot;table table-borderless&quot;&gt;
        &lt;thead&gt;
          &lt;tr&gt;
            &lt;th scope=&quot;col&quot;&gt;#&lt;/th&gt;
            &lt;th scope=&quot;col&quot;&gt;First&lt;/th&gt;
            &lt;th scope=&quot;col&quot;&gt;Last&lt;/th&gt;
            &lt;th scope=&quot;col&quot;&gt;Handle&lt;/th&gt;
          &lt;/tr&gt;
        &lt;/thead&gt;
        &lt;tbody&gt;
          &lt;tr&gt;
            &lt;th scope=&quot;row&quot;&gt;1&lt;/th&gt;
            &lt;td&gt;Mark&lt;/td&gt;
            &lt;td&gt;Otto&lt;/td&gt;
            &lt;td&gt;@mdo&lt;/td&gt;
          &lt;/tr&gt;
          &lt;tr&gt;
            &lt;th scope=&quot;row&quot;&gt;2&lt;/th&gt;
            &lt;td&gt;Jacob&lt;/td&gt;
            &lt;td&gt;Thornton&lt;/td&gt;
            &lt;td&gt;@fat&lt;/td&gt;
          &lt;/tr&gt;
          &lt;tr&gt;
            &lt;th scope=&quot;row&quot;&gt;3&lt;/th&gt;
            &lt;td colspan=&quot;2&quot;&gt;Larry the Bird&lt;/td&gt;
            &lt;td&gt;@twitter&lt;/td&gt;
          &lt;/tr&gt;
        &lt;/tbody&gt;
      &lt;/table&gt;</code></pre>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12">
              <h5 class="card-title mb-1">Hoverable rows</h5>
              <p>Add <span class="text-danger">.table-hover</span> to enable a hover state on table rows within a <code
                  class="text-danger">&lt;tbody&gt;</code>.</p>
              <div class="card mb-5">
                <ul class="nav nav-pills py-3 px-4" role="tablist">
                  <li class="nav-item" role="presentation">
                    <a class="nav-link active" href="javascript:void(0)" (click)="onMenuTab5('1')"
                      [ngClass]="{'active': viewTab5}">View</a>
                  </li>
                  <li class="nav-item" role="presentation">
                    <a class="nav-link" href="javascript:void(0)" (click)="onMenuTab5('2')"
                      [ngClass]="{'active': htmlTab5}">HTML
                      code</a>
                  </li>
                </ul>
                <div class="card-body border-top">
                  <div class="tab-content">
                    <div class="tab-pane fade show active" id="table-view-6" [ngClass]="{'show active': viewTab5}">
                      <table class="table table-hover">
                        <thead>
                          <tr>
                            <th scope="col">#</th>
                            <th scope="col">First</th>
                            <th scope="col">Last</th>
                            <th scope="col">Handle</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <th scope="row">1</th>
                            <td>Mark</td>
                            <td>Otto</td>
                            <td>@mdo</td>
                          </tr>
                          <tr>
                            <th scope="row">2</th>
                            <td>Jacob</td>
                            <td>Thornton</td>
                            <td>@fat</td>
                          </tr>
                          <tr>
                            <th scope="row">3</th>
                            <td colspan="2">Larry the Bird</td>
                            <td>@twitter</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="tab-pane fade" id="table-code-6" [ngClass]="{'show active': htmlTab5}">
                      <pre><code class="language-html">&lt;table class=&quot;table table-hover&quot;&gt;
        &lt;thead&gt;
          &lt;tr&gt;
            &lt;th scope=&quot;col&quot;&gt;#&lt;/th&gt;
            &lt;th scope=&quot;col&quot;&gt;First&lt;/th&gt;
            &lt;th scope=&quot;col&quot;&gt;Last&lt;/th&gt;
            &lt;th scope=&quot;col&quot;&gt;Handle&lt;/th&gt;
          &lt;/tr&gt;
        &lt;/thead&gt;
        &lt;tbody&gt;
          &lt;tr&gt;
            &lt;th scope=&quot;row&quot;&gt;1&lt;/th&gt;
            &lt;td&gt;Mark&lt;/td&gt;
            &lt;td&gt;Otto&lt;/td&gt;
            &lt;td&gt;@mdo&lt;/td&gt;
          &lt;/tr&gt;
          &lt;tr&gt;
            &lt;th scope=&quot;row&quot;&gt;2&lt;/th&gt;
            &lt;td&gt;Jacob&lt;/td&gt;
            &lt;td&gt;Thornton&lt;/td&gt;
            &lt;td&gt;@fat&lt;/td&gt;
          &lt;/tr&gt;
          &lt;tr&gt;
            &lt;th scope=&quot;row&quot;&gt;3&lt;/th&gt;
            &lt;td colspan=&quot;2&quot;&gt;Larry the Bird&lt;/td&gt;
            &lt;td&gt;@twitter&lt;/td&gt;
          &lt;/tr&gt;
        &lt;/tbody&gt;
      &lt;/table&gt;</code></pre>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12">
              <h5 class="card-title mb-1">Contextual classes</h5>
              <p>Use contextual classes to color table rows or individual cells.</p>
              <div class="card mb-5">
                <ul class="nav nav-pills py-3 px-4" role="tablist">
                  <li class="nav-item" role="presentation">
                    <a class="nav-link active" href="javascript:void(0)" (click)="onMenuTab6('1')"
                      [ngClass]="{'active': viewTab6}">View</a>
                  </li>
                  <li class="nav-item" role="presentation">
                    <a class="nav-link" href="javascript:void(0)" (click)="onMenuTab6('2')"
                      [ngClass]="{'active': htmlTab6}">HTML
                      code</a>
                  </li>
                </ul>
                <div class="card-body border-top">
                  <div class="tab-content">
                    <div class="tab-pane fade show active" id="table-view-7" [ngClass]="{'show active': viewTab6}">
                      <table class="table">
                        <thead>
                          <tr>
                            <th scope="col">Class</th>
                            <th scope="col">Heading</th>
                            <th scope="col">Heading</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr class="table-active">
                            <th scope="row">Active</th>
                            <td>Cell</td>
                            <td>Cell</td>
                          </tr>
                          <tr>
                            <th scope="row">Default</th>
                            <td>Cell</td>
                            <td>Cell</td>
                          </tr>


                          <tr class="table-primary">
                            <th scope="row">Primary</th>
                            <td>Cell</td>
                            <td>Cell</td>
                          </tr>
                          <tr class="table-secondary">
                            <th scope="row">Secondary</th>
                            <td>Cell</td>
                            <td>Cell</td>
                          </tr>
                          <tr class="table-success">
                            <th scope="row">Success</th>
                            <td>Cell</td>
                            <td>Cell</td>
                          </tr>
                          <tr class="table-danger">
                            <th scope="row">Danger</th>
                            <td>Cell</td>
                            <td>Cell</td>
                          </tr>
                          <tr class="table-warning">
                            <th scope="row">Warning</th>
                            <td>Cell</td>
                            <td>Cell</td>
                          </tr>
                          <tr class="table-info">
                            <th scope="row">Info</th>
                            <td>Cell</td>
                            <td>Cell</td>
                          </tr>
                          <tr class="table-light">
                            <th scope="row">Light</th>
                            <td>Cell</td>
                            <td>Cell</td>
                          </tr>
                          <tr class="table-dark">
                            <th scope="row">Dark</th>
                            <td>Cell</td>
                            <td>Cell</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="tab-pane fade" id="table-code-7" [ngClass]="{'show active': htmlTab6}">
                      <pre><code class="language-html">&lt;!-- On rows --&gt;
    &lt;tr class=&quot;table-active&quot;&gt;...&lt;/tr&gt;

    &lt;tr class=&quot;table-primary&quot;&gt;...&lt;/tr&gt;
    &lt;tr class=&quot;table-secondary&quot;&gt;...&lt;/tr&gt;
    &lt;tr class=&quot;table-success&quot;&gt;...&lt;/tr&gt;
    &lt;tr class=&quot;table-danger&quot;&gt;...&lt;/tr&gt;
    &lt;tr class=&quot;table-warning&quot;&gt;...&lt;/tr&gt;
    &lt;tr class=&quot;table-info&quot;&gt;...&lt;/tr&gt;
    &lt;tr class=&quot;table-light&quot;&gt;...&lt;/tr&gt;
    &lt;tr class=&quot;table-dark&quot;&gt;...&lt;/tr&gt;

    &lt;!-- On cells (`td` or `th`) --&gt;
    &lt;tr&gt;
        &lt;td class=&quot;table-active&quot;&gt;...&lt;/td&gt;

        &lt;td class=&quot;table-primary&quot;&gt;...&lt;/td&gt;
        &lt;td class=&quot;table-secondary&quot;&gt;...&lt;/td&gt;
        &lt;td class=&quot;table-success&quot;&gt;...&lt;/td&gt;
        &lt;td class=&quot;table-danger&quot;&gt;...&lt;/td&gt;
        &lt;td class=&quot;table-warning&quot;&gt;...&lt;/td&gt;
        &lt;td class=&quot;table-info&quot;&gt;...&lt;/td&gt;
        &lt;td class=&quot;table-light&quot;&gt;...&lt;/td&gt;
        &lt;td class=&quot;table-dark&quot;&gt;...&lt;/td&gt;
    &lt;/tr&gt;</code></pre>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12">
              <div class="card mb-4">
                <div class="card-header">
                  <h6 class="mb-0">Responsive tables</h6>
                </div>
                <div class="card-body">
                  <p>Create responsive tables by wrapping any <code class="text-danger">.table</code> with <code
                      class="text-danger">.table-responsive</code>, making the table scroll
                    horizontally at each <code class="text-danger">max-width</code> breakpoint of up to (but not
                    including) 576px, 768px, 992px, and 1120px, respectively.</p>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <!-- End Page Default -->

    </div>
    <!-- End chat body -->

  </div>
  <!-- Main Body: Content -->
</div>
